// extracted by mini-css-extract-plugin
module.exports = {"component":"da51a739f7--component--ZRXJY","time":"da51a739f7--time--n2VnG","info":"da51a739f7--info--R5_H_"};